<div class="mt-md-3 container-fluid" *ngIf="isTypeComponent">
    <div class="row">
      <div class="col-12">

        <!-- Loading State -->
        <div *ngIf="loading_person || loading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <p class="mt-3 text-muted">Cargando información del pago...</p>
        </div>

        <!-- Content with scroll -->
        <div *ngIf="!loading_person && !loading" style="max-height: 75vh; overflow-y: auto; padding-right: 10px;">
          <ng-container *ngIf="person?.person" class="mt-2">
            <!-- Payments Content for Modal -->
            <div class="w-100">
                <div class="bg-white mt-3 mb-4 p-4 rounded shadow-sm border" *ngFor="let item of resp_paymentsCredits">

                        <div class="mt-2 w-100 text-end" *ngIf="!item?.payment?.reconciled_payment && item?.payment?.status && item?.payment?.typeTransaction!=='PENDING' && (!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['pagos.pagos_registrados.update']))">
                            <i (click)="setPayment(item)" class="far fa-edit text-primary cursor-pounter"></i>
                        </div>

                        <div class="row mt-2 row-k">

                              <div class="col-12">
                                  <div *ngIf="item?.payment?.status && item?.payment?.payments_similar.length>0">
                                      <div class="alert alert-warning mt-1" *ngFor="let ps of item?.payment?.payments_similar">
                                          <i class="fas fa-exclamation-triangle text-danger"></i> Existe otro pago con la misma referencia, cuenta depósito y monto.<br>Código de pago: <b>{{ ps.code }}</b>
                                      </div>
                                  </div>
                              </div>

                              <div class="col-12 mt-2">
                                  <div *ngIf="item?.payment?.file" [title]="item?.payment?.file?.url" class="text-primary fz-14" style="cursor:pointer">
                                      <span (click)="redirectIMG(item?.payment?.file, fileViewerModal)">
                                        <i class="fas fa-paperclip me-1"></i>Ver Adjunto
                                      </span>
                                  </div>
                              </div>

                            <div class="col-md-6">
                                <div class="small text-secondary">Código</div>
                                <div class="text-dark small fw-bold"> {{item?.payment?.code}}</div>
                            </div>

                            <div class="col-md-6">
                                <div class="text-end ms-auto">
                                    <div *ngIf="item?.payment?.typeTransaction !== 'DOMICILIATION'">
                                        <div class="small text-secondary">Conciliación</div>
                                        <div class="small text-success fw-bold" [ngClass]="{'text-success': item?.payment?.typeTransaction == 'AUTO','text-secondary': item?.payment?.typeTransaction != 'AUTO'}"> {{item?.payment?.typeTransaction == 'AUTO'? item?.payment?.responseAutoConfirm?.source?findAutopago(item?.payment?.responseAutoConfirm?.source):'Auto':(item?.payment?.typeTransaction==='PENDING'?'Automática':'Manual')}}</div>
                                    </div>
                                    <div *ngIf="item?.payment?.typeTransaction === 'DOMICILIATION'">
                                        <div class="small text-secondary">Pago Domiciliado {{ item?.payment?.account_payment?.bank?.name }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="small text-secondary">Monto total</div>
                                <div class="text-dark fw-bold"> {{item?.payment?.amount | currency:'USD':'': '1.2-2'}} USD</div>
                            </div>

                            <div class="col-md-6 text-end">
                                <div class="small text-secondary">Estatus</div>
                                <div class="text-success fw-bold" *ngIf="item?.payment?.reconciled_payment">
                                    <div *ngIf="item?.payment?.payment_annulled">
                                        <span class="badge text-bg-primary"><i class="fas fa-undo me-1"></i>Devoluci&oacute;n</span>
                                    </div>
                                    <div *ngIf="!item?.payment?.payment_annulled && item?.payment?.typeTransaction!=='DOMICILIATION' && item?.payment?.status">
                                        <span class="badge text-bg-success">Aprobado</span>
                                    </div>
                                    <div *ngIf="!item?.payment?.payment_annulled && item?.payment?.typeTransaction==='DOMICILIATION'">
                                        <div *ngIf="item?.payment?.amount===0">
                                            <span class="badge text-bg-danger">{{item?.payment?.description}}</span>
                                        </div>
                                        <div *ngIf="item?.payment?.amount>0 && item?.payment?.status">
                                            <span class="badge text-bg-success">Aprobado</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="fw-bold" *ngIf="!item?.payment?.reconciled_payment && item?.payment?.status">
                                    <span class="badge text-bg-warning" *ngIf="item?.payment?.typeTransaction!=='PENDING'">Por conciliar</span>
                                    <span class="badge text-bg-warning" *ngIf="item?.payment?.typeTransaction==='PENDING'">En proceso de validación</span>
                                </div>

                                <div class="fw-bold" *ngIf="!item?.payment?.status">
                                    <div *ngIf="item?.payment?.typeTransaction!=='DOMICILIATION'">
                                        <span class="badge text-bg-danger">{{item?.payment?.typeTransaction == 'AUTO'?'Transacción fallida': 'Anulado'}}</span>
                                    </div>
                                    <div *ngIf="item?.payment?.typeTransaction==='DOMICILIATION'">
                                        <span class="badge text-bg-danger">Rechazado por el Banco</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-6">
                                <div class="small text-secondary">Tasa de cambio a la fecha del pago</div>
                                <div class="fw-bold text-dark"> USD 1 = BS {{item?.payment?.rate | currency:'USD':'': '1.2-2'}}</div>
                            </div>

                            <div class="col-6 text-end">
                                <div class="small text-secondary">Monto del pago</div>
                                <div class="fw-bold text-dark"> {{item?.payment?.counterValue | currency:'USD':'': '1.2-2'}} {{item?.payment?.currency?.name}}</div>
                            </div>

                            <div class="col-12">
                                <div class="small text-secondary">Tipo de producto</div>
                                <div class="fw-bold" *ngIf="item?.payment?.typeProduct">
                                    {{item?.payment?.typeProduct}}
                                </div>
                               <div class="fw-bold" *ngIf="!(item?.payment?.typeProduct)">
                                    CREDIT
                               </div>
                            </div>

                            <div class="col-6">
                                <div class="small text-secondary">Fecha conciliación / Anulación</div>
                                <div class="fw-bold" *ngIf="item?.payment?.reconciled_payment_date || item?.payment?.reconciled_payment_ejecutive">
                                <div class="text-dark"> {{item?.payment?.reconciled_payment_date | date: 'dd/MM/yyyy h:mm:ss a'}}</div>
                                <div class="text-dark" *ngIf="!item?.payment?.reconciled_payment"> {{item?.payment?.reconciled_payment_ejecutive | date: 'dd/MM/yyyy h:mm:ss a'}}</div>
                               </div>
                               <div *ngIf="!(item?.payment?.reconciled_payment || item?.payment?.reconciled_payment_ejecutive)">
                                    -
                               </div>
                            </div>

                            <div class="col-6 text-end">
                                <div class="small text-secondary">Responsable</div>
                                <div class="fw-bold text-dark small text-capitalize">
                                    <div class="text-dark text-capitalize">{{item?.payment?.reconciled_payment_ejecutive?.name}} {{item?.payment?.reconciled_payment_ejecutive?.lastName}}</div>
                                    <div class="text-dark text-capitalize" *ngIf="!item?.payment?.reconciled_payment_ejecutive">-</div>
                                </div>
                            </div>

                            <div class="col-12 text-end">
                                <div class="small text-secondary">
                                    {{ item?.payment?.status ? 'Descripción' : 'Motivo de anulación' }}
                                </div>
                                <div class="text-dark fw-bold"> {{item?.payment?.description || '-'}}</div>
                            </div>

                            <div class="col-6">
                                <div class="small text-secondary">Fecha de reporte</div>
                                <div class="text-dark fw-bold"> {{item?.payment?.date | date: 'dd/MM/yyyy h:mm:ss a'}}</div>
                            </div>

                            <div class="col-6 text-end">
                              <div class="small text-secondary">Canal de reporte</div>
                              <div class="fw-bold text-dark small text-capitalize" *ngIf="item?.payment?.creator_api?.includes('Caja')">
                                {{item?.payment?.creator_api}}
                              </div>
                              <div class="fw-bold text-dark small text-capitalize" *ngIf="(item?.payment?.creator_api === 'APP' || item?.payment?.creator_api === 'CONSOLE' || item?.payment?.creator_api === 'CHATBOT') && !item?.payment?.creator_api?.includes('Caja')">
                                {{item?.payment?.creator_api}} 
                                <ng-container *ngIf="item?.payment?.creator?.name || item?.payment?.creator?.lastName">
                                  / {{ item?.payment?.creator?.name }} {{ item?.payment?.creator?.lastName }}
                                </ng-container>
                              </div>
                              <div class="fw-bold text-dark small text-capitalize" *ngIf="!item?.payment?.creator_api">-</div>
                            </div>

                            <div class="col-6">
                                <div class="small text-secondary">Fecha de pago</div>
                                <div class="text-dark fw-bold" *ngIf="item?.payment?.register_payment_date"> {{ item?.payment?.register_payment_date | date: 'dd/MM/yyyy' }}</div>
                                <div class="text-dark fw-bold" *ngIf="!item?.payment?.register_payment_date"> {{ item?.payment?.date | date: 'dd/MM/yyyy'  }}</div>
                            </div>

                            <div class="col-6 text-end">
                                <div class="small text-secondary">Responsable edición</div>
                                <div class="text-dark fw-bold" *ngIf="item?.payment?.payment_edit_ejecutive"> {{item?.payment?.payment_edit_ejecutive?.name}} {{item?.payment?.payment_edit_ejecutive?.lastName}}</div>
                                <div class="fw-bold text-dark small text-capitalize" *ngIf="!item?.payment?.payment_edit_ejecutive">-</div>
                            </div>

                            <div class="col-6">
                                <div class="small text-secondary">Banco origen</div>
                                <div class="text-dark fw-bold"> {{(item?.payment?.bankCode && banks[item?.payment?.bankCode]) || '-'}}</div>
                            </div>

                            <div class="col-6 text-end">
                                <div class="small text-secondary">Método de pago</div>
                                <div class="text-dark fw-bold"> {{item?.payment?.account_payment?.payment_method?.name || '-'}}</div>
                            </div>

                            <div class="col-12" *ngIf="item?.payment?.automatic_direct_debit?.error">
                                <div class="small text-secondary">Motivo de Rechazo</div>
                                <div class="text-dark">
                                    {{item?.payment?.automatic_direct_debit?.error?.description }}
                                </div>
                            </div>

                            <div class="col-6 mt-2">
                                <div class="small text-secondary">Teléfono de origen</div>
                                <div class="text-dark fw-bold"> {{item?.payment?.phone ? item?.payment?.phone :'-'}}</div>
                            </div>

                            <div class="col-6 text-end">
                                <div class="small text-secondary">Número de referencia</div>
                                <div class="text-dark fw-bold"> {{item?.payment?.paymentMethodId || '-'}}</div>
                            </div>

                            <div class="col-6">
                                <div class="small text-secondary">Cuenta origen (Últimos 6)</div>
                                <div class="text-dark fw-bold"> {{item?.payment?.account || '-' }}</div>
                            </div>

                            <div class="col-6 text-end">
                                <div class="small text-secondary">Cédula/Rif titular de la Cta.</div>
                                <div class="text-dark fw-bold"> {{item?.payment?.cid != 'V' ? item?.payment?.cid :'-'}}</div>
                            </div>

                            <div class="col-12">
                                <div class="small text-secondary">Banco destino</div>
                                <div class="text-dark fw-bold"> {{item?.payment?.account_payment?.bank?.name || '-'}} </div>
                            </div>

                            <div class="col-6">
                                <div class="small text-secondary">Teléfono destino</div>
                                <div class="text-dark fw-bold">{{item?.payment?.account_payment?.phone || '-'}} </div>
                            </div>

                            <div class="col-6 text-end">
                                <div class="small text-secondary">Cuenta destino</div>
                                <div class="text-dark fw-bold">{{item?.payment?.account_payment?.number || '-'}} </div>
                            </div>

                            <div class="col-6" *ngIf="item?.payment?.totalPaymentDue > 0 && item?.payment?.status">
                                <div class="small text-secondary">Monto sin aplicar</div>
                                <div class="text-dark fw-bold">{{item?.payment?.totalPaymentDue | currency:'USD':'': '1.2-2'}} USD </div>
                            </div>

                            <!-- Additional payment sections -->
                            <div class="fw-bold text-secondary mt-2 mb-2" *ngIf="item?.payment?.responseAutoConfirm">Voucher</div>

                            <div class="text-dark fw-bold fz-12 mb-2" *ngIf="item?.payment?.responseAutoConfirm?.descripcion">
                                {{item?.payment?.responseAutoConfirm?.descripcion}}
                            </div>

                            <div class="row" *ngIf="item?.payment?.responseAutoConfirm?.voucher">
                                <div class="col-12 col-md-6">
                                    <div class="voucher p-2 text-dark text-uppercase" [innerHTML]="item?.payment?.responseAutoConfirm?.voucher">
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-2" *ngIf="item?.payment?.special_flow_data">
                                <div class="col-12 mt-1">
                                    <div class="small text-secondary"><span *ngIf="item?.payment?.special_flow_data?.description">{{ item?.payment?.special_flow_data?.description }} - </span>Registrado por <span class="text-dark fw-bold">{{ item?.payment?.special_flow_data?.registered_by?.name }} {{ item?.payment?.special_flow_data?.registered_by?.lastName }}</span> el {{ item?.payment?.special_flow_data?.registered_at | date:'dd/MM/yyyy HH:mm' }}</div>
                                </div>
                            </div>

                            <div class="row mt-2 row-k" *ngIf="item.payment.payment_pending">
                                <div class="col-6"></div>
                                <div class="col-6 text-end">
                                    <div class="small text-secondary">
                                        <span class="badge text-bg-success" [class.text-bg-success]="item.payment.payment_pending.status==='PENDING'" [class.text-bg-secondary]="item.payment.payment_pending.status==='EXPIRED'" [class.text-bg-primary]="item.payment.payment_pending.status==='COMPLETE'"><i class="fas fa-clock"></i>&nbsp;Asíncrono</span>
                                        <small *ngIf="item.payment.payment_pending.status==='PENDING'"><br>{{ item.payment.payment_pending.next_attempt_at | date: 'dd/MM/yyyy h:mm:ss a' }}</small>
                                        <small *ngIf="item.payment.payment_pending.status==='COMPLETE'"><br>Completado</small>
                                        <small *ngIf="item.payment.payment_pending.status==='EXPIRED'"><br>No se pudo validar</small>
                                        <small *ngIf="item.payment.payment_pending.attempt > 0"><br>{{ item.payment.payment_pending.attempt }} intento(s)</small>
                                        <small *ngIf="item.payment.payment_pending.attempt === 0"><br>Sin iniciar</small>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3 row-k" *ngIf="item?.installMent?.length > 0">
                                <div class="fw-bold text-secondary">Distribución</div>
                                <ng-container class="mt-2" *ngFor=" let item2 of item?.installMent ;let i = index">
                                    <ng-container>
                                        <div class="col-6">
                                            <div class="small">
                                                <span>
                                                    {{item2?.installMent?.invoice?.identifier}} /
                                                    {{ item2?.installMent?.order < 1 ? 'Inicial': 'Cuota '+ item2?.installMent?.order }}
                                                    <div class="small text-secondary small">{{item2?.installMent?.code }}</div>
                                                </span>
                                            </div>
                                            <div class="small text-secondary small">{{item?.payment?.installMent?.code }}</div>
                                        </div>
                                        <div class="col-6 text-end">
                                            <div class="text-dark"> {{item2?.amount | currency:'USD':'': '1.2-2'}} USD</div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>

                            <!-- 🏥 SECCIÓN DE REPORTE DE SEGUROS -->
                            <div class="row mt-2 row-k" *ngIf="item.payment.params?.insurance_report || (item.payment.typeTransaction === 'DOMICILIATION' && item.payment.typeProduct && item.payment.typeProduct.startsWith('SEGURO'))">
                                <div class="col-6"></div>
                                <div class="col-6 text-end">
                                    <div class="small text-secondary">
                                        <span class="badge"
                                            [class.text-bg-success]="item.payment.params?.insurance_report?.reportado"
                                            [class.text-bg-warning]="!item.payment.params?.insurance_report?.reportado && item.payment.params?.insurance_report?.current_intento > 0 && !item.payment.params?.insurance_report?.permanently_failed"
                                            [class.text-bg-danger]="item.payment.params?.insurance_report?.permanently_failed"
                                            [class.text-bg-info]="!item.payment.params?.insurance_report?.reportado && item.payment.params?.insurance_report?.current_intento === 0">
                                            <i class="fas fa-file-medical-alt"></i>&nbsp;Reporte a Aseguradora
                                        </span>

                                        <!-- 📊 Contador de intentos -->
                                        <small class="d-block mt-1" *ngIf="item.payment.params?.insurance_report">
                                            <strong>{{ item.payment.params.insurance_report.current_intento || 0 }} de {{
                                                item.payment.params.insurance_report.limite || 10 }} intentos</strong>
                                        </small>

                                        <!-- ✅ Fecha de reporte exitoso -->
                                        <small class="d-block" *ngIf="item.payment.params?.insurance_report?.reportado && item.payment.params?.insurance_report?.reported_at">
                                            <i class="fas fa-check-circle text-success"></i> Reportado: {{
                                            formatAsyncDate(item.payment.params.insurance_report.reported_at) }}
                                        </small>

                                        <!-- ⏰ Último intento -->
                                        <small class="d-block" *ngIf="!item.payment.params?.insurance_report?.reportado && item.payment.params?.insurance_report?.last_attempt_at">
                                            <i class="fas fa-clock text-muted"></i> Último: {{
                                            formatAsyncDate(item.payment.params.insurance_report.last_attempt_at) }}
                                        </small>

                                        <!-- ❌ Fallido permanentemente -->
                                        <small class="d-block text-danger" *ngIf="item.payment.params?.insurance_report?.permanently_failed">
                                            <i class="fas fa-exclamation-triangle"></i> Límite de intentos excedido
                                        </small>

                                        <!-- 📋 Historial de intentos (clickeable) -->
                                        <small class="d-block mt-1"
                                            *ngIf="item.payment.params?.insurance_report?.history && item.payment.params.insurance_report.history.length > 0">
                                            <a href="javascript:void(0)" class="text-decoration-none text-primary"
                                                (click)="openInsuranceReportHistoryModal(item.payment)">
                                                <i class="fas fa-history"></i> Ver historial ({{
                                                item.payment.params.insurance_report.history.length }})
                                            </a>
                                        </small>

                                        <!-- 🔄 Botón Reportar/Reintentar a Aseguradora (cualquier medio de pago con seguro pendiente) -->
                                        <div class="mt-2"
                                            *ngIf="!item.payment.params?.insurance_report?.reportado">
                                            <button
                                                class="btn btn-sm btn-outline-warning"
                                                [disabled]="item.payment._retryingInsurance"
                                                (click)="openInsuranceReport(item)">
                                                <i class="fas" [ngClass]="item.payment._retryingInsurance ? 'fa-spinner fa-spin' : 'fa-redo'"></i>
                                                {{ item.payment._retryingInsurance ? 'Reportando...' :
                                                   (item.payment.params?.insurance_report ? 'Reintentar Reporte' : 'Reportar a Seguro') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row row-k" *ngIf="item?.paymen_categ_concept_deduc?.length > 0">
                                <ng-container *ngFor=" let item3 of item?.paymen_categ_concept_deduc ;let i = index">
                                    <div class="col-8" *ngIf="item3?.category_concept_deduction?.concept_deduction?.name == 'IGTF'">
                                        <div class="small">{{item3?.category_concept_deduction?.concept_deduction?.name}}
                                            <span class="text-secondary" *ngIf="item3?.category_concept_deduction.isPorcent">{{item3?.category_concept_deduction?.amount}}%</span> </div>
                                    </div>
                                    <div class="col-4 text-end" *ngIf="item3?.category_concept_deduction?.concept_deduction?.name == 'IGTF'">
                                        <div class="text-dark"> {{item3?.amount | currency:'USD':'': '1.2-2'}} USD</div>
                                    </div>
                                </ng-container>
                            </div>

                            <div class="row mt-3 row-k" *ngIf="item?.fees?.length > 0">
                                <div class="fw-bold text-secondary">Penalidades</div>
                                <ng-container class="mt-2" *ngFor=" let item2 of item?.fees ;let i = index">
                                    <ng-container>
                                        <div class="col-6">
                                            <!-- Fee de installment (tiene invoice y cuota) -->
                                            <ng-container *ngIf="item2?.fee_installment && item2?.fee_installment?.installment; else feePersonBlock">
                                                <div class="small">
                                                    <span>
                                                        {{item2?.fee_installment?.installment?.invoice?.identifier}} /
                                                        {{ item2?.fee_installment?.installment?.order < 1 ? 'Inicial': 'Cuota '+ item2?.fee_installment?.installment?.order }}
                                                        <div class="">{{item2?.fee_installment?.fee?.concept_deduction?.name }}</div>
                                                    </span>
                                                    <div class="small text-secondary small">{{item2?.fee_installment?.installment?.code }}</div>
                                                </div>
                                            </ng-container>
                                            <!-- Fee de persona (no tiene invoice ni cuota, solo el nombre del fee) -->
                                            <ng-template #feePersonBlock>
                                                <div class="small">
                                                    <span>
                                                        {{item2?.fee?.concept_deduction?.name}}
                                                    </span>
                                                    <div class="small text-secondary small">{{item2?.fee?.code}}</div>
                                                </div>
                                            </ng-template>
                                        </div>
                                        <div class="col-6 text-end">
                                            <div class="text-dark"> {{item2?.amount | currency:'USD':'': '1.2-2'}} USD</div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>

                            <div class="row mt-3 row-k" *ngIf="item?.payment?.fees?.length > 0 && item?.fees?.length === 0">
                                <div class="fw-bold text-secondary" *ngIf="validar_penalidad(item?.payment?.fees)">Penalidad</div>
                                <ng-container *ngFor=" let row of item?.paymen_categ_concept_deduc;let i = index">
                                    <ng-container class="mt-2" *ngIf="(row?.fee && item?.payment?.reconciled_payment && item?.payment?.status && item?.payment?.typeTransaction!=='PENDING')">
                                        <div class="col-6">
                                            <div class="small">
                                                <span>
                                                    {{ row?.installMent?.invoice?.identifier + ' / Cuota '+ row?.installMent?.order}} <br>
                                                    {{ row?.fee?.concept_deduction?.name }}
                                                </span>
                                            </div>
                                            <div class="small text-secondary small">{{row?.fee?.code }}</div>
                                        </div>
                                        <div class="col-6 text-end" *ngIf="item?.payment?.reconciled_payment && item?.payment?.status && item?.payment?.typeTransaction!=='PENDING'">
                                            <div class="text-dark">
                                                {{feeService.calculateAmount(row?.fee) | currency:'USD':'': '1.2-2'}} USD
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>

                            <!-- 🔄 ASYNC PAYMENT INFO SECTION -->
                            <div class="row mt-2 row-k" *ngIf="item.payment.async">
                                <div class="col-6"></div>
                                <div class="col-6 text-end">
                                    <div class="small text-secondary">Estado Async</div>
                                    <div class="fw-bold">
                                        <span class="badge me-2"
                                              [ngClass]="{
                                                'text-bg-success': item.payment.async.status === 'completed',
                                                'text-bg-warning': item.payment.async.status === 'pending',
                                                'text-bg-danger': item.payment.async.status === 'failed',
                                                'text-bg-info': item.payment.async.status === 'processing'
                                              }">
                                          {{ item.payment.async.status }}
                                        </span>
                                        <button type="button"
                                                class="btn btn-outline-primary btn-sm"
                                                (click)="openAsyncHistoryModal(item)"
                                                title="Ver historial de verificación asíncrona">
                                          <i class="fas fa-history"></i>
                                        </button>
                                    </div>
                                    <div class="small text-muted">
                                        Intentos: {{ item.payment.async.attempt || 0 }}/{{ item.payment.async.max_attempts || 0 }}
                                    </div>
                                </div>
                            </div>

                           <div class="row mt-4">
                            <div class="col-12 col-md-8" *ngIf="_auth.hasAccessOrProfile('finanzas', ['OWNER','ANALIST']) && !item?.payment?.reconciled_payment && item?.payment?.status && item?.payment?.typeTransaction!=='PENDING'">
                                        <div class="input-group">
                                            <button *ngIf="_auth.hasAnyPermission(['finanzas.verificacion_pagos.activate_review', 'pagos.pagos_registrados.activate_review']) || !_auth.hasRbac$.getValue()" (click)="changeSubStatus(item?.payment?.code,subStatus[item.payment.code] == 'REVISION'? 'NA':'REVISION')" [ngClass]="{'btn-primary': subStatus[item.payment.code] == 'REVISION','btn-secondary':subStatus[item.payment.code] != 'REVISION' }" class="btn btn-sm">
                                             {{subStatus[item.payment.code] == 'REVISION'?'Inactivar revisión' : 'Activar revisión'}}
                                            </button>
                                        </div>
                            </div>

                            <div *ngIf="_auth.hasAccessOrProfile('finanzas', ['OWNER','ANALIST']) && !item?.payment?.reconciled_payment && item?.payment?.status && item?.payment?.typeTransaction!=='PENDING'" class="col-12 col-md-4 text-end">
                                <button *ngIf="_auth.hasAnyPermission(['finanzas.verificacion_pagos.approve', 'pagos.pagos_registrados.approve']) || !_auth.hasRbac$.getValue()" [disabled]="loadcon" type="button" (click)="concilidarPago(item?.payment)" class="btn btn-primary mt-2 btn-sm">
                                    Aprobar
                                    <span *ngIf="loadcon">...</span> </button>
                                <button *ngIf="_auth.hasAnyPermission(['finanzas.verificacion_pagos.cancel', 'pagos.pagos_registrados.cancel']) || !_auth.hasRbac$.getValue()" [disabled]="loadcon2" type="button" (click)="cancelPayment(item?.payment?.code)" class="btn btn-outline-danger ms-2 mt-2 btn-sm">
                                    Anular
                                <span *ngIf="loadcon2">...</span> </button>
                            </div>

                            <!-- Anular pago conciliado SIN distribución (Devolución de fondos). Solo OWNER. -->
                            <div *ngIf="canCancelReconciledUndistributed(item)" class="col-12 text-end mt-2">
                                <button [disabled]="loadcon2" type="button"
                                        (click)="cancelReconciledUndistributed(item?.payment?.code)"
                                        class="btn btn-outline-warning btn-sm"
                                        title="Anular pago conciliado sin distribución (Devolución de fondos)">
                                    <i class="fas fa-undo me-1"></i> Anular (Devolución)
                                </button>
                            </div>
                        </div>
                        </div>


                    </div>
                </div>
            </ng-container>

        </div>
    </div>
  </div>
  </div>

  <!-- Modern Section for non-type components -->
  <div class="min-h-screen py-8" *ngIf="!isTypeComponent">
      <div class="max-w-6xl mx-auto px-4">

          <!-- Customer Profile Section -->
          <div *ngIf="!loading && person?.person" class="mb-6">
              <div class="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
                  <div [routerLink]="['/console/person/profile/',person?.person?.code]"
                       class="flex items-center space-x-4 cursor-pointer hover:opacity-80 transition-opacity">
                      <div class="flex-shrink-0">
                          <img
                              *ngIf="person?.person?.file_selfie"
                              class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
                              [src]="sanitize(person?.person?.file_selfie?.url)"
                              alt="Avatar del cliente"
                          />
                          <img
                              *ngIf="!person?.person?.file_selfie && person?.person?.gender != 'F'"
                              class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
                              [src]="sanitize('../assets/public/images/avatar.png')"
                              alt="Avatar del cliente"
                          />
                          <img
                              *ngIf="!person?.person?.file_selfie && person?.person?.gender == 'F'"
                              class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
                              [src]="sanitize('../assets/public/images/avatara-female.png')"
                              alt="Avatar del cliente"
                          />
                      </div>
                      <div class="flex-1">
                          <h2 class="text-xl font-bold text-gray-900 capitalize hover:text-blue-600 transition-colors">
                              {{person?.person?.name}} {{person?.person?.lastName}}
                          </h2>
                          <div class="flex flex-wrap gap-4 mt-1 text-sm text-gray-600">
                              <div class="flex items-center gap-1">
                                  <i class="fas fa-id-card text-blue-600"></i>
                                  <span>{{getIdentity(person)}}</span>
                              </div>
                              <div class="flex items-center gap-1">
                                  <i class="fas fa-phone text-blue-600"></i>
                                  <span>{{getContact(person)}}</span>
                              </div>
                              <div *ngIf="getEmailContact(person)" class="flex items-center gap-1">
                                  <i class="fas fa-envelope text-blue-600"></i>
                                  <span>{{getEmailContact(person)}}</span>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <!-- Loading State -->
          <div *ngIf="loading_person || loading" class="text-center py-12">
              <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-4"></div>
              <p class="text-gray-600">Cargando información...</p>
          </div>

          <!-- Title Section -->
          <div *ngIf="!loading_person && !loading" class="mb-6">
              <h1 class="text-2xl font-bold text-gray-900 text-center">
                  <i class="fas fa-money-bill-wave text-blue-600 mr-2"></i>
                  Pagos realizados
              </h1>
          </div>

          <!-- 💎 FILTROS: TIPO DE PRODUCTO Y ESTADO -->
          <div class="d-flex justify-content-center gap-3 mb-4 flex-wrap" *ngIf="!loading_person">
              
              <!-- Filtro de Tipo de Producto -->
              <div class="position-relative product-search-input" style="width: 350px; max-width: 100%;">
                  <!-- Barra de Búsqueda Principal (estilo form-floating como en post) -->
                  <div class="form-floating">
                      <input
                          type="text"
                          class="form-control"
                          id="productSearchPayments"
                          [(ngModel)]="productSearchTerm"
                          (input)="filterProductsSearch()"
                          (focus)="openDropdown()"
                          (click)="openDropdown()"
                          [readonly]="!showDropdown"
                          placeholder="Buscar tipo de producto..."
                          autocomplete="off">
                      <label for="productSearchPayments">
                          <i class="fas fa-search me-2"></i>
                          Buscar tipo de producto
                      </label>
                      <!-- Botón limpiar -->
                      <button
                          type="button"
                          class="btn btn-sm btn-outline-secondary position-absolute end-0 top-50 translate-middle-y me-2"
                          *ngIf="productSearchTerm && (selectedProducts.length > 1 || (selectedProducts.length === 1 && selectedProducts[0] !== 'CREDIT'))"
                          (click)="clearProductSearch()"
                          style="z-index: 10;">
                          <i class="fas fa-times"></i>
                      </button>
                  </div>

                  <!-- Dropdown Elegante -->
                  <div
                      *ngIf="showDropdown"
                      class="dropdown-menu show position-absolute w-100 mt-2 shadow-lg border-0 filter-dropdown"
                      style="z-index: 1050;"
                  >
                      <!-- Header con contador -->
                      <div class="px-3 py-2 bg-light border-bottom">
                          <div class="d-flex align-items-center justify-content-between">
                              <small class="text-muted fw-medium">
                                  <i class="fas fa-list me-1 text-primary"></i>
                                  {{ filteredProductArray.length }} producto{{ filteredProductArray.length > 1 ? 's' : '' }} encontrado{{ filteredProductArray.length > 1 ? 's' : '' }}
                              </small>
                              <span class="badge bg-primary">{{ tempSelectedProducts.length }} seleccionado{{ tempSelectedProducts.length > 1 ? 's' : '' }}</span>
                          </div>
                      </div>

                      <!-- Lista de Opciones -->
                      <div class="filter-options" style="max-height: 300px; overflow-y: auto;">

                          <!-- Loading Skeleton -->
                          <div *ngIf="filterStates.isLoadingProducts" class="p-3">
                              <div *ngFor="let item of [1,2,3]" class="d-flex align-items-center mb-3">
                                  <div class="placeholder-glow flex-grow-1">
                                      <span class="placeholder col-8"></span>
                                  </div>
                              </div>
                          </div>

                          <!-- Opciones Reales -->
                          <div *ngIf="!filterStates.isLoadingProducts">
                              <div
                                  *ngFor="let item of filteredProductArray; trackBy: trackByProductCode"
                                  class="filter-option-item px-3 py-3 border-bottom cursor-pointer"
                                  [class.selected]="isProductSelected(item?.params?.code)"
                                  (click)="onProductSelectionChange(item?.params?.code, !isProductSelected(item?.params?.code)); $event.stopPropagation()"
                              >
                                  <div class="d-flex align-items-center">
                                      <!-- Icono -->
                                      <div class="me-3">
                                          <i class="fas fa-cube text-primary"></i>
                                      </div>

                                      <!-- Texto -->
                                      <div class="flex-grow-1">
                                          <div class="fw-medium text-dark">{{ item?.params?.name || item?.params?.code }}</div>
                                          <small class="text-muted d-block">Código: {{ item?.params?.code }}</small>
                                          <small class="text-muted d-block" *ngIf="item?.params?.dinamic_code && item?.params?.dinamic_code.length > 0">
                                              Etiqueta: {{ item?.params?.dinamic_code[0] }}
                                          </small>
                                      </div>

                                      <!-- Check de seleccionado -->
                                      <div *ngIf="isProductSelected(item?.params?.code)">
                                          <i class="fas fa-check text-primary fa-lg"></i>
                                      </div>
                                  </div>
                              </div>

                              <!-- Mensaje cuando no hay resultados -->
                              <div *ngIf="filteredProductArray.length === 0" class="text-center py-4">
                                  <i class="fas fa-search fa-3x text-muted mb-3"></i>
                                  <h6 class="text-muted">No se encontraron productos</h6>
                                  <p class="text-muted small">Intenta con otro término de búsqueda</p>
                              </div>
                          </div>
                      </div>

                      <!-- Footer con Controles -->
                      <div class="px-3 py-3 bg-light border-top">
                          <!-- Info -->
                          <div class="d-flex align-items-center justify-content-between mb-3">
                              <small class="text-muted">
                                  <i class="fas fa-info-circle text-primary me-1"></i>
                                  {{ tempSelectedProducts.length }} de {{ productArray.length }} seleccionados
                              </small>

                              <!-- Botón Limpiar -->
                              <button
                                  *ngIf="tempSelectedProducts.length > 1 || (tempSelectedProducts.length === 1 && tempSelectedProducts[0] !== 'CREDIT')"
                                  type="button"
                                  class="btn btn-sm btn-outline-secondary"
                                  (click)="clearAllFilters()"
                              >
                                  <i class="fas fa-times me-1"></i>
                                  Limpiar
                              </button>
                          </div>

                          <!-- Botones de Acción -->
                          <div class="d-flex gap-2">
                              <!-- Cancelar -->
                              <button
                                  type="button"
                                  class="btn btn-outline-secondary flex-fill"
                                  (click)="closeDropdown()"
                                  [disabled]="filterStates.isApplyingFilter"
                              >
                                  Cancelar
                              </button>

                              <!-- Aplicar -->
                              <button
                                  type="button"
                                  class="btn btn-primary flex-fill"
                                  (click)="applyFilters()"
                                  [disabled]="filterStates.isApplyingFilter"
                              >
                                  <span *ngIf="!filterStates.isApplyingFilter">
                                      <i class="fas fa-check me-1"></i>
                                      Aplicar
                                  </span>
                                  <span *ngIf="filterStates.isApplyingFilter">
                                      <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                                      Aplicando...
                                  </span>
                              </button>
                          </div>
                      </div>
                  </div>
              </div>

          </div>

          <!-- Estado de Error del filtro de productos -->
          <div class="d-flex justify-content-center mb-4" *ngIf="!loading_person">
              <div style="width: 650px; max-width: 100%;">
                  <div *ngIf="filterStates.hasError" class="alert alert-danger" role="alert">
                      <div class="d-flex align-items-start">
                          <i class="fas fa-exclamation-triangle me-2 mt-1"></i>
                          <div class="flex-grow-1">
                              <strong>Error en el filtro</strong>
                              <div class="small">{{ filterStates.errorMessage }}</div>
                              <button
                                  type="button"
                                  class="btn btn-sm btn-outline-danger mt-2"
                                  (click)="retryOperation()"
                              >
                                  <i class="fas fa-redo me-1"></i>
                                  Reintentar
                              </button>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <!-- Payments Content -->
          <div class="max-w-4xl mx-auto">
              <!-- Loading de Resultados -->
              <div *ngIf="filterStates.isLoadingResults" class="mt-4">
                  <div *ngFor="let item of [1,2,3]" class="bg-white mt-4 my-3 p-4 bg-body2 rounded shadow-sm">
                      <div class="placeholder-glow">
                          <!-- Edit icon area -->
                          <div class="d-flex justify-content-end mb-3">
                              <span class="placeholder rounded-circle" style="width: 20px; height: 20px;"></span>
                          </div>

                          <!-- Sección Principal -->
                          <div class="row g-3 mb-4">
                              <!-- Código -->
                              <div class="col-md-6">
                                  <div class="mb-2">
                                      <span class="placeholder col-3 rounded" style="height: 12px;"></span>
                                  </div>
                                  <span class="placeholder col-7 rounded" style="height: 18px;"></span>
                              </div>
                              <!-- Conciliación -->
                              <div class="col-md-6 text-end">
                                  <div class="mb-2">
                                      <span class="placeholder col-5 rounded" style="height: 12px;"></span>
                                  </div>
                                  <span class="placeholder col-4 rounded" style="height: 18px;"></span>
                              </div>
                          </div>

                          <!-- Sección Monetaria -->
                          <div class="row g-3 mb-4">
                              <!-- Monto total -->
                              <div class="col-md-6">
                                  <div class="mb-2">
                                      <span class="placeholder col-4 rounded" style="height: 12px;"></span>
                                  </div>
                                  <span class="placeholder col-8 rounded" style="height: 20px;"></span>
                              </div>
                              <!-- Estatus -->
                              <div class="col-md-6 text-end">
                                  <div class="mb-2">
                                      <span class="placeholder col-3 rounded" style="height: 12px;"></span>
                                  </div>
                                  <span class="placeholder col-6 rounded-pill" style="height: 24px;"></span>
                              </div>
                          </div>

                          <!-- Sección de Tasas y Montos -->
                          <div class="row g-3 mb-4">
                              <div class="col-6">
                                  <div class="mb-2">
                                      <span class="placeholder col-10 rounded" style="height: 12px;"></span>
                                  </div>
                                  <span class="placeholder col-8 rounded" style="height: 16px;"></span>
                              </div>
                              <div class="col-6 text-end">
                                  <div class="mb-2">
                                      <span class="placeholder col-7 rounded" style="height: 12px;"></span>
                                  </div>
                                  <span class="placeholder col-9 rounded" style="height: 16px;"></span>
                              </div>
                          </div>

                          <!-- Tipo de producto -->
                          <div class="mb-4">
                              <div class="mb-2">
                                  <span class="placeholder col-4 rounded" style="height: 12px;"></span>
                              </div>
                              <span class="placeholder col-3 rounded" style="height: 18px;"></span>
                          </div>

                          <!-- Sección de Fechas y Responsables -->
                          <div class="row g-3 mb-4">
                              <div class="col-6">
                                  <div class="mb-2">
                                      <span class="placeholder col-9 rounded" style="height: 12px;"></span>
                                  </div>
                                  <span class="placeholder col-7 rounded" style="height: 16px;"></span>
                              </div>
                              <div class="col-6 text-end">
                                  <div class="mb-2">
                                      <span class="placeholder col-5 rounded" style="height: 12px;"></span>
                                  </div>
                                  <span class="placeholder col-6 rounded" style="height: 16px;"></span>
                              </div>
                          </div>

                          <!-- Sección de Canales y Reportes -->
                          <div class="row g-3 mb-4">
                              <div class="col-6">
                                  <div class="mb-2">
                                      <span class="placeholder col-6 rounded" style="height: 12px;"></span>
                                  </div>
                                  <span class="placeholder col-8 rounded" style="height: 16px;"></span>
                              </div>
                              <div class="col-6 text-end">
                                  <div class="mb-2">
                                      <span class="placeholder col-7 rounded" style="height: 12px;"></span>
                                  </div>
                                  <span class="placeholder col-9 rounded" style="height: 16px;"></span>
                              </div>
                          </div>

                          <!-- Sección Bancaria -->
                          <div class="row g-3 mb-4">
                              <div class="col-6">
                                  <div class="mb-2">
                                      <span class="placeholder col-5 rounded" style="height: 12px;"></span>
                                  </div>
                                  <span class="placeholder col-7 rounded" style="height: 16px;"></span>
                              </div>
                              <div class="col-6 text-end">
                                  <div class="mb-2">
                                      <span class="placeholder col-6 rounded" style="height: 12px;"></span>
                                  </div>
                                  <span class="placeholder col-5 rounded" style="height: 16px;"></span>
                              </div>
                          </div>

                          <!-- Sección de Cuentas -->
                          <div class="row g-3 mb-4">
                              <div class="col-6">
                                  <div class="mb-2">
                                      <span class="placeholder col-8 rounded" style="height: 12px;"></span>
                                  </div>
                                  <span class="placeholder col-5 rounded" style="height: 16px;"></span>
                              </div>
                              <div class="col-6 text-end">
                                  <div class="mb-2">
                                      <span class="placeholder col-7 rounded" style="height: 12px;"></span>
                                  </div>
                                  <span class="placeholder col-6 rounded" style="height: 16px;"></span>
                              </div>
                          </div>

                          <!-- Separador visual -->
                          <hr class="my-4" style="opacity: 0.1;">

                          <!-- Sección de Botones -->
                          <div class="row g-3 align-items-center">
                              <div class="col-12 col-md-8">
                                  <span class="placeholder col-6 rounded" style="height: 36px;"></span>
                              </div>
                              <div class="col-12 col-md-4 text-end">
                                  <div class="d-flex gap-2 justify-content-end">
                                      <span class="placeholder rounded" style="width: 80px; height: 36px;"></span>
                                      <span class="placeholder rounded" style="width: 80px; height: 36px;"></span>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <!-- Overlay de Carga -->
              <div *ngIf="filterStates.isApplyingFilter && !filterStates.isLoadingResults"
                   class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                   style="z-index: 1055; background: rgba(255,255,255,0.9);">
                  <div class="text-center">
                      <div class="spinner-border text-primary mb-3" role="status">
                          <span class="visually-hidden">Cargando...</span>
                      </div>
                      <h5 class="text-primary">Aplicando filtros</h5>
                      <p class="text-muted mb-0">Obteniendo resultados...</p>
                  </div>
              </div>

              <!-- Resultados Reales -->
              <ng-container *ngIf="!loading && !loading_person && person?.person && !filterStates.isLoadingResults" class="mt-2">
                  <div class="bg-white mt-4 my-3 p-3 bg-body2  rounded shadow-sm" *ngFor="let item of resp_paymentsCredits">

                      <div class=" mt-2  w-100 text-end " *ngIf="!item?.payment?.reconciled_payment &&  item?.payment?.status &&  item?.payment?.typeTransaction!=='PENDING' && (!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['pagos.pagos_registrados.update']))">
                          <i (click)="setPayment(item)" class="far fa-edit text-primary cursor-pounter" ></i>
                      </div>

                      <div class="row mt-2 row-k">

                            <div class="col-12 ">
                                <div  *ngIf="item?.payment?.status && item?.payment?.payments_similar.length>0">
                                    <div class="alert alert-warning mt-1" *ngFor="let ps of item?.payment?.payments_similar">
                                        <i class="fas fa-exclamation-triangle text-danger"></i> Existe otro pago con la misma referencia, cuenta depósito y monto.<br>Código de pago: <b>{{ ps.code }}</b>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 mt-2  ">
                                <div *ngIf="item?.payment?.file" [title]="item?.payment?.file?.url" class="text-primary fz-14" style="cursor:pointer">
                                    <span (click)="redirectIMG(item?.payment?.file, fileViewerModal)">
                                      <i class="fas fa-paperclip me-1"></i>Ver Adjunto
                                    </span>
                                </div>
                            </div>

                          <div class="col-md-6   ">
                              <div class="small text-secondary">Código</div>
                              <div class=" text-dark small fw-bold"> {{item?.payment?.code}}</div>
                          </div>

                          <div class="col-md-6   ">
                              <div class="text-end ms-auto">
                                  <div *ngIf="item?.payment?.typeTransaction !== 'DOMICILIATION'">
                                      <div class="small text-secondary">Conciliación</div>
                                      <div class=" small text-success fw-bold" [ngClass]="{'text-success': item?.payment?.typeTransaction == 'AUTO','text-secondary': item?.payment?.typeTransaction != 'AUTO'}"> {{item?.payment?.typeTransaction == 'AUTO'? item?.payment?.responseAutoConfirm?.source?findAutopago(item?.payment?.responseAutoConfirm?.source):'Auto':(item?.payment?.typeTransaction==='PENDING'?'Automática':'Manual')}}</div>
                                  </div>
                                  <div *ngIf="item?.payment?.typeTransaction === 'DOMICILIATION'">
                                      <div class="small text-secondary">Pago Domiciliado {{ item?.payment?.account_payment?.bank?.name }}</div>
                                  </div>
                              </div>
                          </div>

                          <div class="col-md-6">
                              <div class="small text-secondary">Monto total</div>
                              <div class=" text-dark fw-bold"> {{item?.payment?.amount | currency:'USD':'': '1.2-2'}} USD</div>
                          </div>

                          <div class="col-md-6 text-end ">
                              <div class="small text-secondary">Estatus</div>
                              <div class="text-success  fw-bold" *ngIf="item?.payment?.reconciled_payment">
                                  <div *ngIf="item?.payment?.payment_annulled">
                                      <span class="badge text-bg-primary"><i class="fas fa-undo me-1"></i>Devoluci&oacute;n</span>
                                  </div>
                                  <div *ngIf="!item?.payment?.payment_annulled && item?.payment?.typeTransaction!=='DOMICILIATION' && item?.payment?.status">
                                      <span class="badge text-bg-success">Aprobado</span>
                                  </div>
                                  <div *ngIf="!item?.payment?.payment_annulled && item?.payment?.typeTransaction==='DOMICILIATION'">
                                      <div *ngIf="item?.payment?.amount===0">
                                          <span class="badge text-bg-danger">{{item?.payment?.description}}</span>
                                      </div>
                                      <div *ngIf="item?.payment?.amount>0 && item?.payment?.status">
                                          <span class="badge text-bg-success">Aprobado</span>
                                      </div>
                                  </div>
                              </div>

                              <div class=" fw-bold" *ngIf="!item?.payment?.reconciled_payment &&  item?.payment?.status">
                                  <span class="badge text-bg-warning" *ngIf="item?.payment?.typeTransaction!=='PENDING'">Por conciliar</span>
                                  <span class="badge text-bg-warning" *ngIf="item?.payment?.typeTransaction==='PENDING'">En proceso de validación</span>
                              </div>

                              <div  class=" fw-bold" *ngIf="!item?.payment?.status">
                                  <div *ngIf="item?.payment?.typeTransaction!=='DOMICILIATION'">
                                      <span class="badge text-bg-danger">{{item?.payment?.typeTransaction == 'AUTO'?'Transacción fallida': 'Anulado'}}</span>
                                  </div>
                                  <div *ngIf="item?.payment?.typeTransaction==='DOMICILIATION'">
                                      <span class="badge text-bg-danger">Rechazado por el Banco</span>
                                  </div>
                              </div>
                          </div>

                          <div class="col-6 ">
                              <div class="small text-secondary">Tasa de cambio a la fecha del pago</div>
                              <div class=" fw-bold text-dark "> USD 1 = BS {{item?.payment?.rate | currency:'USD':'': '1.2-2'}}</div>
                          </div>

                          <div class="col-6 text-end">
                              <div class="small text-secondary">Monto del pago </div>
                              <div class=" fw-bold  text-dark"> {{item?.payment?.counterValue | currency:'USD':'': '1.2-2'}} {{item?.payment?.currency?.name}}</div>
                          </div>

                          <div class="col-12 " >
                              <div class="small text-secondary">Tipo de producto</div>
                              <div class=" fw-bold " *ngIf="item?.payment?.typeProduct ">
                                  {{item?.payment?.typeProduct}}
                              </div>
                             <div class=" fw-bold" *ngIf="!(item?.payment?.typeProduct)">
                                  CREDIT
                             </div>
                          </div>

                          <div class="col-6 " >
                              <div class="small text-secondary">Fecha conciliación / Anulación</div>
                              <div class=" fw-bold " *ngIf="item?.payment?.reconciled_payment_date || item?.payment?.reconciled_payment_ejecutive ">
                              <div class=" text-dark"> {{item?.payment?.reconciled_payment_date | date: 'dd/MM/yyyy h:mm:ss a'}}</div>
                              <div class=" text-dark" *ngIf="!item?.payment?.reconciled_payment"> {{item?.payment?.reconciled_payment_ejecutive | date: 'dd/MM/yyyy h:mm:ss a'}}</div>
                             </div>
                             <div *ngIf="!(item?.payment?.reconciled_payment || item?.payment?.reconciled_payment_ejecutive)">
                                  -
                             </div>
                          </div>

                          <div class="col-6 text-end">
                              <div class="small text-secondary ">Responsable </div>
                              <div class=" fw-bold text-dark small text-capitalize" >
                                  <div class=" text-dark  text-capitalize"  >{{item?.payment?.reconciled_payment_ejecutive?.name}} {{item?.payment?.reconciled_payment_ejecutive?.lastName}}</div>
                                  <div class=" text-dark  text-capitalize" *ngIf="!item?.payment?.reconciled_payment_ejecutive"  >-</div>
                              </div>
                          </div>

                          <div class="col-12  text-end" >
                              <div class="small text-secondary">
                                  {{ item?.payment?.status ? 'Descripción' : 'Motivo de anulación' }}
                              </div>
                              <div class=" text-dark fw-bold" > {{item?.payment?.description || '-'}}</div>
                          </div>

                          <div class="col-6">
                              <div class="small text-secondary ">Fecha de reporte</div>
                              <div class=" text-dark fw-bold"> {{item?.payment?.date | date: 'dd/MM/yyyy h:mm:ss a'}}</div>
                          </div>

                          <div class="col-6 text-end">
                            <div class="small text-secondary ">Canal de reporte </div>
                            <div class=" fw-bold text-dark small text-capitalize"  *ngIf="item?.payment?.creator_api?.includes('Caja')">
                              {{item?.payment?.creator_api}}
                            </div>
                            <div class=" fw-bold text-dark small text-capitalize"  *ngIf="(item?.payment?.creator_api === 'APP' || item?.payment?.creator_api === 'CONSOLE' || item?.payment?.creator_api === 'CHATBOT') && !item?.payment?.creator_api?.includes('Caja')">
                              {{item?.payment?.creator_api}}
                               <ng-container *ngIf="item?.payment?.creator?.name || item?.payment?.creator?.lastName">
                                / {{ item?.payment?.creator?.name }} {{ item?.payment?.creator?.lastName }}
                              </ng-container>
                            </div>
                            <div class=" fw-bold text-dark small text-capitalize" *ngIf="!item?.payment?.creator_api" >-</div>
                        </div>

                          <div class="col-6" >
                              <div class="small text-secondary">Fecha de pago</div>
                              <div class=" text-dark fw-bold" *ngIf="item?.payment?.register_payment_date"> {{ item?.payment?.register_payment_date | date: 'dd/MM/yyyy'  }}</div>
                              <div class=" text-dark fw-bold" *ngIf="!item?.payment?.register_payment_date"> {{ item?.payment?.date | date: 'dd/MM/yyyy' }}</div>
                          </div>

                          <div class="col-6  text-end" >
                              <div class="small text-secondary">  Responsable edición  </div>
                              <div class=" text-dark fw-bold"  *ngIf="item?.payment?.payment_edit_ejecutive">  {{item?.payment?.payment_edit_ejecutive?.name}} {{item?.payment?.payment_edit_ejecutive?.lastName}}</div>
                              <div class=" fw-bold text-dark small text-capitalize" *ngIf="!item?.payment?.payment_edit_ejecutive" >-</div>
                          </div>

                          <div class="col-6   "  >
                              <div class="small text-secondary">Banco origen </div>
                              <div class=" text-dark fw-bold"> {{(item?.payment?.bankCode  && banks[item?.payment?.bankCode])  || '-'}}</div>
                          </div>

                          <div class="col-6  text-end" >
                              <div class="small text-secondary">Método de pago</div>
                              <div class=" text-dark fw-bold" >  {{item?.payment?.account_payment?.payment_method?.name || '-'}}</div>
                          </div>

                          <div class="col-12" *ngIf="item?.payment?.automatic_direct_debit?.error">
                              <div class="small text-secondary">Motivo de Rechazo</div>
                              <div class=" text-dark">
                                  {{item?.payment?.automatic_direct_debit?.error?.description }}
                              </div>
                          </div>

                          <div class="col-6 mt-2" >
                              <div class="small text-secondary">Teléfono de origen</div>
                              <div class=" text-dark fw-bold"  > {{item?.payment?.phone ? item?.payment?.phone :'-'}}</div>
                          </div>

                          <div class="col-6  text-end " >
                              <div class="small text-secondary">Número de referencia</div>
                              <div class=" text-dark fw-bold"> {{item?.payment?.paymentMethodId  || '-'}}</div>
                          </div>

                          <div class="col-6" >
                              <div class="small text-secondary">Cuenta origen (Últimos 6)</div>
                              <div class=" text-dark  fw-bold"> {{item?.payment?.account || '-' }}</div>
                          </div>

                          <div class="col-6  text-end" >
                              <div class="small text-secondary">Cédula/Rif titular de la Cta.</div>
                              <div class=" text-dark  fw-bold" > {{item?.payment?.cid != 'V' ? item?.payment?.cid :'-'}}</div>
                          </div>

                          <div class="col-12"  >
                              <div class="small text-secondary">Banco destino</div>
                              <div class=" text-dark  fw-bold"> {{item?.payment?.account_payment?.bank?.name || '-'}} </div>
                          </div>

                          <div class="col-6" >
                              <div class="small text-secondary">Teléfono destino</div>
                              <div class=" text-dark  fw-bold">{{item?.payment?.account_payment?.phone || '-'}} </div>
                          </div>

                          <div class="col-6  text-end" >
                              <div class="small text-secondary">Cuenta destino</div>
                              <div class=" text-dark  fw-bold" >{{item?.payment?.account_payment?.number || '-'}} </div>
                          </div>

                          <div class="col-6" *ngIf="item?.payment?.totalPaymentDue > 0 && item?.payment?.status" >
                              <div class="small text-secondary">Monto sin aplicar</div>
                              <div class=" text-dark  fw-bold">{{item?.payment?.totalPaymentDue | currency:'USD':'': '1.2-2'}} USD </div>
                          </div>

                          <!-- Additional payment sections continue here -->
                          <div class="fw-bold text-secondary mt-2 mb-2" *ngIf="item?.payment?.responseAutoConfirm">Voucher</div>

                          <div class="text-dark  fw-bold fz-12 mb-2" *ngIf="item?.payment?.responseAutoConfirm?.descripcion">
                              {{item?.payment?.responseAutoConfirm?.descripcion}}
                          </div>

                          <div class="row" *ngIf="item?.payment?.responseAutoConfirm?.voucher">
                              <div class="col-12 col-md-6">
                                  <div class="voucher p-2 text-dark text-uppercase" [innerHTML]="item?.payment?.responseAutoConfirm?.voucher">
                                  </div>
                              </div>
                          </div>

                          <div class="row mt-2" *ngIf="item?.payment?.special_flow_data">
                              <div class="col-12 mt-1">
                                  <div class="small text-secondary"><span *ngIf="item?.payment?.special_flow_data?.description">{{ item?.payment?.special_flow_data?.description }} - </span>Registrado por <span class="text-dark fw-bold">{{ item?.payment?.special_flow_data?.registered_by?.name }} {{ item?.payment?.special_flow_data?.registered_by?.lastName }}</span> el {{ item?.payment?.special_flow_data?.registered_at | date:'dd/MM/yyyy HH:mm' }}</div>
                              </div>
                          </div>

                          <div class="row mt-2 row-k" *ngIf="item.payment.payment_pending">
                              <div class="col-6" ></div>
                              <div class="col-6  text-end" >
                                  <div class="small text-secondary">
                                      <span class="badge text-bg-success" [class.text-bg-success]="item.payment.payment_pending.status==='PENDING'" [class.text-bg-secondary]="item.payment.payment_pending.status==='EXPIRED'" [class.text-bg-primary]="item.payment.payment_pending.status==='COMPLETE'"><i class="fas fa-clock"></i>&nbsp;Asíncrono</span>
                                      <small *ngIf="item.payment.payment_pending.status==='PENDING'"><br>{{ item.payment.payment_pending.next_attempt_at | date: 'dd/MM/yyyy h:mm:ss a' }}</small>
                                      <small *ngIf="item.payment.payment_pending.status==='COMPLETE'"><br>Completado</small>
                                      <small *ngIf="item.payment.payment_pending.status==='EXPIRED'"><br>No se pudo validar</small>
                                      <small *ngIf="item.payment.payment_pending.attempt > 0"><br>{{ item.payment.payment_pending.attempt }} intento(s)</small>
                                      <small *ngIf="item.payment.payment_pending.attempt === 0"><br>Sin iniciar</small>
                                  </div>
                              </div>
                          </div>

                          <div class="row mt-3 row-k" *ngIf="item?.installMent?.length > 0">
                              <div class="fw-bold text-secondary">Distribución</div>
                              <ng-container class="mt-2" *ngFor=" let item2 of item?.installMent ;let i = index">
                                  <ng-container >
                                      <div class="col-6">
                                          <div class="small ">
                                              <span>
                                                  {{item2?.installMent?.invoice?.identifier}} /
                                                  {{ item2?.installMent?.order < 1 ? 'Inicial': 'Cuota '+ item2?.installMent?.order }}
                                                  <div class="small text-secondary small">{{item2?.installMent?.code }}</div>
                                              </span>
                                          </div>
                                          <div class="small text-secondary small">{{item?.payment?.installMent?.code }}</div>
                                      </div>
                                      <div class="col-6  text-end ">
                                          <div class=" text-dark"> {{item2?.amount | currency:'USD':'': '1.2-2'}} USD</div>
                                      </div>
                                  </ng-container>
                              </ng-container>
                          </div>

                          <!-- 🏥 SECCIÓN DE REPORTE DE SEGUROS -->
                          <div class="row mt-2 row-k" *ngIf="item.payment.params?.insurance_report || (item.payment.typeTransaction === 'DOMICILIATION' && item.payment.typeProduct && item.payment.typeProduct.startsWith('SEGURO'))">
                              <div class="col-6"></div>
                              <div class="col-6 text-end">
                                  <div class="small text-secondary">
                                      <span class="badge"
                                          [class.text-bg-success]="item.payment.params?.insurance_report?.reportado"
                                          [class.text-bg-warning]="!item.payment.params?.insurance_report?.reportado && item.payment.params?.insurance_report?.current_intento > 0 && !item.payment.params?.insurance_report?.permanently_failed"
                                          [class.text-bg-danger]="item.payment.params?.insurance_report?.permanently_failed"
                                          [class.text-bg-info]="!item.payment.params?.insurance_report?.reportado && item.payment.params?.insurance_report?.current_intento === 0">
                                          <i class="fas fa-file-medical-alt"></i>&nbsp;Reporte a Aseguradora
                                      </span>

                                      <!-- 📊 Contador de intentos -->
                                      <small class="d-block mt-1" *ngIf="item.payment.params?.insurance_report">
                                          <strong>{{ item.payment.params.insurance_report.current_intento || 0 }} de {{
                                              item.payment.params.insurance_report.limite || 10 }} intentos</strong>
                                      </small>

                                      <!-- ✅ Fecha de reporte exitoso -->
                                      <small class="d-block" *ngIf="item.payment.params?.insurance_report?.reportado && item.payment.params?.insurance_report?.reported_at">
                                          <i class="fas fa-check-circle text-success"></i> Reportado: {{
                                          formatAsyncDate(item.payment.params.insurance_report.reported_at) }}
                                      </small>

                                      <!-- ⏰ Último intento -->
                                      <small class="d-block" *ngIf="!item.payment.params?.insurance_report?.reportado && item.payment.params?.insurance_report?.last_attempt_at">
                                          <i class="fas fa-clock text-muted"></i> Último: {{
                                          formatAsyncDate(item.payment.params.insurance_report.last_attempt_at) }}
                                      </small>

                                      <!-- ❌ Fallido permanentemente -->
                                      <small class="d-block text-danger" *ngIf="item.payment.params?.insurance_report?.permanently_failed">
                                          <i class="fas fa-exclamation-triangle"></i> Límite de intentos excedido
                                      </small>

                                      <!-- 📋 Historial de intentos (clickeable) -->
                                      <small class="d-block mt-1"
                                          *ngIf="item.payment.params?.insurance_report?.history && item.payment.params.insurance_report.history.length > 0">
                                          <a href="javascript:void(0)" class="text-decoration-none text-primary"
                                              (click)="openInsuranceReportHistoryModal(item.payment)">
                                              <i class="fas fa-history"></i> Ver historial ({{
                                              item.payment.params.insurance_report.history.length }})
                                          </a>
                                      </small>

                                      <!-- 🔄 Botón Reportar/Reintentar a Aseguradora (cualquier medio de pago con seguro pendiente) -->
                                      <div class="mt-2"
                                          *ngIf="!item.payment.params?.insurance_report?.reportado">
                                          <button
                                              class="btn btn-sm btn-outline-warning"
                                              [disabled]="item.payment._retryingInsurance"
                                              (click)="openInsuranceReport(item)">
                                              <i class="fas" [ngClass]="item.payment._retryingInsurance ? 'fa-spinner fa-spin' : 'fa-redo'"></i>
                                              {{ item.payment._retryingInsurance ? 'Reportando...' :
                                                 (item.payment.params?.insurance_report ? 'Reintentar Reporte' : 'Reportar a Seguro') }}
                                          </button>
                                      </div>
                                  </div>
                              </div>
                          </div>

                          <div class="row row-k" *ngIf="item?.paymen_categ_concept_deduc?.length > 0">
                              <ng-container *ngFor=" let item3 of item?.paymen_categ_concept_deduc ;let i = index">
                                  <div class="col-8" *ngIf="item3?.category_concept_deduction?.concept_deduction?.name == 'IGTF'">
                                      <div class="small">{{item3?.category_concept_deduction?.concept_deduction?.name}}
                                          <span class="text-secondary" *ngIf="item3?.category_concept_deduction.isPorcent">{{item3?.category_concept_deduction?.amount}}%</span> </div>
                                  </div>
                                  <div class="col-4 text-end " *ngIf="item3?.category_concept_deduction?.concept_deduction?.name  == 'IGTF'">
                                      <div class=" text-dark"> {{item3?.amount | currency:'USD':'': '1.2-2'}} USD</div>
                                  </div>
                              </ng-container>
                          </div>

                          <div class="row mt-3 row-k" *ngIf="item?.fees?.length > 0">
                              <div class="fw-bold text-secondary">Penalidades</div>
                              <ng-container class="mt-2" *ngFor=" let item2 of item?.fees ;let i = index">
                                  <ng-container >
                                      <div class="col-6">
                                          <!-- Fee de installment (tiene invoice y cuota) -->
                                          <ng-container *ngIf="item2?.fee_installment && item2?.fee_installment?.installment; else feePersonBlock2">
                                              <div class="small ">
                                                  <span>
                                                      {{item2?.fee_installment?.installment?.invoice?.identifier}} /
                                                      {{ item2?.fee_installment?.installment?.order < 1 ? 'Inicial': 'Cuota '+ item2?.fee_installment?.installment?.order }}
                                                      <div class=" ">{{item2?.fee_installment?.fee.concept_deduction?.name }}</div>
                                                  </span>
                                                  <div class="small text-secondary small">{{item2?.fee_installment?.installment?.code }}</div>
                                              </div>
                                          </ng-container>
                                          <!-- Fee de persona (no tiene invoice ni cuota, solo el nombre del fee) -->
                                          <ng-template #feePersonBlock2>
                                              <div class="small">
                                                  <span>
                                                      {{item2?.fee?.concept_deduction?.name}}
                                                  </span>
                                                  <div class="small text-secondary small">{{item2?.fee?.code}}</div>
                                              </div>
                                          </ng-template>
                                      </div>
                                      <div class="col-6  text-end ">
                                          <div class=" text-dark"> {{item2?.amount | currency:'USD':'': '1.2-2'}} USD</div>
                                      </div>
                                  </ng-container>
                              </ng-container>
                          </div>

                          <div class="row mt-3 row-k" *ngIf="item?.payment?.fees?.length > 0 && item?.fees?.length === 0">
                              <div class="fw-bold text-secondary" *ngIf="validar_penalidad(item?.payment?.fees) ">Penalidad</div>
                              <ng-container *ngFor=" let row of item?.paymen_categ_concept_deduc;let i = index">
                                  <ng-container class="mt-2"  *ngIf="(row?.fee && item?.payment?.reconciled_payment && item?.payment?.status &&  item?.payment?.typeTransaction!=='PENDING')">
                                      <div class="col-6">
                                          <div class="small ">
                                              <span>
                                                  {{ row?.installMent?.invoice?.identifier + ' / Cuota '+ row?.installMent?.order}} <br>
                                                  {{ row?.fee?.concept_deduction?.name  }}
                                              </span>
                                          </div>
                                          <div class="small text-secondary small">{{row?.fee?.code }}</div>
                                      </div>
                                      <div class="col-6  text-end " *ngIf="item?.payment?.reconciled_payment && item?.payment?.status &&  item?.payment?.typeTransaction!=='PENDING'">
                                          <div class=" text-dark">
                                              {{feeService.calculateAmount(row?.fee) | currency:'USD':'': '1.2-2'}} USD
                                          </div>
                                      </div>
                                  </ng-container>
                              </ng-container>
                          </div>

                          <div class="row mt-2 row-k" *ngIf="item.payment.async">
                            <div class="col-6" ></div>
                            <div class="col-6 text-end" >
                               <div class="small text-secondary">
                                  <span class="badge" [class.text-bg-info]="item.payment.async.status==='PENDING'" [class.text-bg-warning]="item.payment.async.status==='RETRYING'" [class.text-bg-primary]="item.payment.async.status==='PROCESSING'" [class.text-bg-success]="item.payment.async.status==='COMPLETED'" [class.text-bg-danger]="item.payment.async.status==='FAILED'"> <i class="fas fa-robot"></i>&nbsp;Verificación Asíncrona </span> <!-- Contador de intentos --> <small class="d-block mt-1"> <strong>{{ item.payment.async.attempt || 0 }} de {{ item.payment.async.max_attempts || 0 }} intentos</strong> </small> <!-- Último intento --> <small class="d-block" *ngIf="item.payment.async.last_attempt_at"> <i class="fas fa-clock text-muted"></i> Último: {{ formatAsyncDate(item.payment.async.last_attempt_at) }} </small> <!-- Próximo intento (solo si está RETRYING) --> <small class="d-block" *ngIf="item.payment.async.status === 'RETRYING' && item.payment.async.next_attempt_at"> <i class="fas fa-forward text-primary"></i> Próximo: {{ formatAsyncDate(item.payment.async.next_attempt_at) }} </small> <!-- Historial de intentos (clickeable) --> <small class="d-block mt-1" *ngIf="item.payment.async.attempt_history && item.payment.async.attempt_history.length > 0"> <a href="javascript:void(0)" class="text-decoration-none text-primary" (click)="openAsyncHistoryModal(item.payment)"> <i class="fas fa-history"></i> Ver historial ({{ item.payment.async.attempt_history.length }}) </a> </small> 
                               </div>
                            </div>
                         </div>

                         <div class="row mt-4">
                         <div class="col-12 col-md-8"  *ngIf="_auth.hasAccessOrProfile('finanzas', ['OWNER','ANALIST']) && !item?.payment?.reconciled_payment &&  item?.payment?.status &&  item?.payment?.typeTransaction!=='PENDING'">
                                     <div class="input-group">
                                         <button *ngIf="_auth.hasAnyPermission(['finanzas.verificacion_pagos.activate_review', 'pagos.pagos_registrados.activate_review']) || !_auth.hasRbac$.getValue()" (click)="changeSubStatus(item?.payment?.code,subStatus[item.payment.code] == 'REVISION'? 'NA':'REVISION')"  [ngClass]="{'btn-primary': subStatus[item.payment.code] == 'REVISION','btn-secondary':subStatus[item.payment.code]   != 'REVISION' }" class="btn btn-sm ">
                                          {{subStatus[item.payment.code] == 'REVISION'?'Inactivar revisión' : 'Activar revisión'}}
                                         </button>
                                     </div>
                         </div>

                         <div *ngIf="_auth.hasAccessOrProfile('finanzas', ['OWNER','ANALIST']) && !item?.payment?.reconciled_payment && item?.payment?.status &&  item?.payment?.typeTransaction!=='PENDING'" class="col-12 col-md-4 text-end">
                             <button *ngIf="_auth.hasAnyPermission(['finanzas.verificacion_pagos.approve', 'pagos.pagos_registrados.approve']) || !_auth.hasRbac$.getValue()" [disabled]="loadcon" type="button" (click)="concilidarPago(item?.payment)" class="btn btn-primary mt-2 btn-sm">
                                 Aprobar
                                 <span *ngIf="loadcon">...</span> </button>
                             <button *ngIf="_auth.hasAnyPermission(['finanzas.verificacion_pagos.cancel', 'pagos.pagos_registrados.cancel']) || !_auth.hasRbac$.getValue()" [disabled]="loadcon2" type="button" (click)="cancelPayment(item?.payment?.code)" class="btn btn-outline-danger  ms-2 mt-2 btn-sm">
                                 Anular
                             <span *ngIf="loadcon2">...</span> </button>
                         </div>

                         <!-- Anular pago conciliado SIN distribución (Devolución de fondos). Solo OWNER. -->
                         <div *ngIf="canCancelReconciledUndistributed(item)" class="col-12 d-flex justify-content-end mt-2">
                             <button [disabled]="loadcon2" type="button"
                                     (click)="cancelReconciledUndistributed(item?.payment?.code)"
                                     class="btn btn-outline-warning btn-sm"
                                     title="Anular pago conciliado sin distribución (Devolución de fondos)">
                                 <i class="fas fa-undo me-1"></i> Anular (Devolución)
                             </button>
                         </div>
                     </div>
                     </div>

                 </div>
             </ng-container>

             <!-- No Data Message -->
             <div *ngIf="!loading && !loading_person &&  person?.person && resp_paymentsCredits?.length < 1" class="text-center py-12">
                 <div class="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                     <i class="fas fa-money-bill-wave text-2xl text-gray-400"></i>
                 </div>
                 <h3 class="text-lg font-medium text-gray-900 mb-2">No se encontraron pagos registrados</h3>
                 <p class="text-gray-500">Este cliente no tiene pagos registrados</p>
             </div>

             <!-- Person Not Found -->
             <div *ngIf="!loading_person && !person?.person" class="text-center py-12">
                 <div class="mx-auto w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mb-4">
                     <i class="fas fa-exclamation-triangle text-2xl text-red-400"></i>
                 </div>
                 <h3 class="text-lg font-medium text-gray-900 mb-2">Cliente no encontrado</h3>
                 <p class="text-red-600">No se encontro person con este id: {{queryParams?.code}}</p>
             </div>
         </div>


            <ng-container *ngIf="loading_person ||  loading ">
                <div class="w-100 text-center mt-2">
                    <img src="./assets/public/images/loading.gif  " alt=" ">
                </div>
            </ng-container>
        </div>
    </div>


    
<!-- MODAL HISTORIAL ASYNC VERIFICATION -->
<div class="modal fade" id="asyncHistoryModal" tabindex="-1" aria-labelledby="asyncHistoryModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
       <div class="modal-content">
          <div class="modal-header bg-primary text-white">
             <h5 class="modal-title" id="asyncHistoryModalLabel"> <i class="fas fa-robot me-2"></i>Historial de Verificación Asíncrona </h5>
             <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button> 
          </div>
          <div class="modal-body">
             <!-- Payment Info Header --> 
             <div class="card mb-3" *ngIf="selectedAsyncPayment">
                <div class="card-body">
                   <div class="row">
                      <div class="col-md-6">
                         <small class="text-muted">Código de Pago</small> 
                         <div class="fw-bold">{{ selectedAsyncPayment.code || 'Sin código' }}</div>
                      </div>
                      <div class="col-md-6">
                         <small class="text-muted">Estado Actual</small> 
                         <div> <span class="badge" [class.text-bg-info]="selectedAsyncPayment.async?.status==='PENDING'" [class.text-bg-warning]="selectedAsyncPayment.async?.status==='RETRYING'" [class.text-bg-primary]="selectedAsyncPayment.async?.status==='PROCESSING'" [class.text-bg-success]="selectedAsyncPayment.async?.status==='COMPLETED'" [class.text-bg-danger]="selectedAsyncPayment.async?.status==='FAILED'" [class.text-bg-secondary]="!selectedAsyncPayment.async?.status"> {{ selectedAsyncPayment.async?.status || 'Sin estado' }} </span> </div>
                      </div>
                   </div>
                </div>
             </div>
             <!-- History Timeline --> 
             <div class="timeline" *ngIf="selectedAsyncPayment?.async?.attempt_history && selectedAsyncPayment.async.attempt_history.length > 0">
                <div class="timeline-item" *ngFor="let attempt of selectedAsyncPayment.async.attempt_history; let i = index"> <div class="timeline-marker" [class.bg-success]="attempt.status === 'COMPLETED'" [class.bg-danger]="attempt.status === 'FAILED'" [class.bg-primary]="attempt.status === 'PROCESSING'"> <i class="fas fa-circle text-white" style="font-size: 8px;"></i> </div>
                <div class="timeline-content">
                   <div class="card">
                      <div class="card-body">
                         <div class="d-flex justify-content-between align-items-start mb-2">
                            <h6 class="card-title mb-0"> <i class="fas fa-redo-alt me-1"></i>Intento #{{ (attempt.attempt || 0) + 1 }} </h6>
                            <span class="badge" [class.text-bg-success]="attempt.status === 'COMPLETED'" [class.text-bg-danger]="attempt.status === 'FAILED'" [class.text-bg-primary]="attempt.status === 'PROCESSING'"> {{ attempt.status }} </span> 
                         </div>
                         <div class="row">
                            <div class="col-md-6">
                               <small class="text-muted">Iniciado</small> 
                               <div class="small">{{ formatAsyncDate(attempt.started_at) }}</div>
                            </div>
                            <div class="col-md-6" *ngIf="attempt.completed_at">
                               <small class="text-muted">Completado</small> 
                               <div class="small">{{ formatAsyncDate(attempt.completed_at) }}</div>
                            </div>
                         </div>
                         <div class="row mt-2" *ngIf="attempt.response_time_ms">
                            <div class="col-md-6">
                               <small class="text-muted">Tiempo de Respuesta</small> 
                               <div class="small">{{ attempt.response_time_ms }}ms</div>
                            </div>
                         </div>
                         <!-- Error Message --> 
                         <div class="mt-2" *ngIf="attempt.error">
                            <small class="text-muted">Error</small> 
                            <div class="alert alert-danger py-1 px-2 small"> <i class="fas fa-exclamation-triangle me-1"></i>{{ attempt.error }} </div>
                         </div>
                         <!-- Voucher Response (solo si existe) --> 
                         <div class="mt-2" *ngIf="attempt.response?.voucher">
                            <small class="text-muted">Voucher de Respuesta</small> 
                            <div class="voucher-container mt-1">
                               <div class="voucher p-2 text-dark text-uppercase border rounded" [innerHTML]="attempt.response.voucher"> </div>
                            </div>
                         </div>
                         <!-- Response Details (si no hay voucher pero hay respuesta) --> 
                         <div class="mt-2" *ngIf="attempt.response && !attempt.response.voucher">
                            <small class="text-muted">Detalles de Respuesta</small> 
                            <div class="alert alert-info py-1 px-2 small">
                               <pre class="mb-0">{{ attempt.response | json }}</pre>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <!-- No History Message --> 
          <div class="text-center py-4" *ngIf="selectedAsyncPayment && (!selectedAsyncPayment?.async?.attempt_history || selectedAsyncPayment.async.attempt_history.length === 0)">
             <i class="fas fa-history text-muted" style="font-size: 3rem;"></i> 
             <h5 class="text-muted mt-2">Sin historial disponible</h5>
             <p class="text-muted">No se encontraron intentos de verificación para este pago.</p>
          </div>
          <!-- No Payment Selected --> 
          <div class="text-center py-4" *ngIf="!selectedAsyncPayment">
             <i class="fas fa-exclamation-triangle text-warning" style="font-size: 3rem;"></i> 
             <h5 class="text-warning mt-2">No hay pago seleccionado</h5>
             <p class="text-muted">Por favor, selecciona un pago para ver su historial.</p>
          </div>
       </div>
       <div class="modal-footer"> <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"> <i class="fas fa-times me-1"></i>Cerrar </button> </div>
    </div>
 </div>
 </div>

<!-- 🏥 MODAL DE HISTORIAL DE REPORTE DE SEGUROS -->
<div class="modal fade" id="insuranceReportHistoryModal" tabindex="-1" aria-labelledby="insuranceReportHistoryModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-primary text-white">
                <h5 class="modal-title" id="insuranceReportHistoryModalLabel">
                    <i class="fas fa-file-medical-alt me-2"></i>Historial de Reporte a Aseguradora
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"
                    (click)="closeInsuranceReportHistoryModal()"></button>
            </div>
            <div class="modal-body">
                <!-- Payment Info Header -->
                <div class="card mb-3" *ngIf="selectedInsuranceReportPayment">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <small class="text-muted">Código de Pago</small>
                                <div class="fw-bold">{{ selectedInsuranceReportPayment.code }}</div>
                            </div>
                            <div class="col-md-6">
                                <small class="text-muted">Monto</small>
                                <div class="fw-bold">{{ selectedInsuranceReportPayment.amount | currency:'USD':'':'1.2-2' }} USD
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-6">
                                <small class="text-muted">Estado Actual</small>
                                <div>
                                    <span class="badge"
                                        [class.text-bg-success]="selectedInsuranceReportPayment.params?.insurance_report?.reportado"
                                        [class.text-bg-warning]="!selectedInsuranceReportPayment.params?.insurance_report?.reportado && selectedInsuranceReportPayment.params?.insurance_report?.current_intento > 0 && !selectedInsuranceReportPayment.params?.insurance_report?.permanently_failed"
                                        [class.text-bg-danger]="selectedInsuranceReportPayment.params?.insurance_report?.permanently_failed"
                                        [class.text-bg-info]="!selectedInsuranceReportPayment.params?.insurance_report?.reportado && selectedInsuranceReportPayment.params?.insurance_report?.current_intento === 0">
                                        {{ selectedInsuranceReportPayment.params?.insurance_report?.reportado ? 'REPORTADO' : 
                                           selectedInsuranceReportPayment.params?.insurance_report?.permanently_failed ? 'FALLIDO' : 
                                           selectedInsuranceReportPayment.params?.insurance_report?.current_intento > 0 ? 'REINTENTANDO' : 'PENDIENTE' }}
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <small class="text-muted">Intentos</small>
                                <div class="fw-bold">{{ selectedInsuranceReportPayment.params?.insurance_report?.current_intento || 0 }} de {{
                                    selectedInsuranceReportPayment.params?.insurance_report?.limite || 10 }}</div>
                            </div>
                        </div>
                        <div class="row mt-2" *ngIf="selectedInsuranceReportPayment.params?.insurance_report?.policy_code">
                            <div class="col-md-12">
                                <small class="text-muted">Código de Póliza</small>
                                <div class="fw-bold">{{ selectedInsuranceReportPayment.params.insurance_report.policy_code }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- History Timeline -->
                <div class="timeline"
                    *ngIf="selectedInsuranceReportPayment?.params?.insurance_report?.history && selectedInsuranceReportPayment.params.insurance_report.history.length > 0">
                    <div class="timeline-item"
                        *ngFor="let attempt of selectedInsuranceReportPayment.params.insurance_report.history; let i = index">
                        <div class="timeline-marker" [class.bg-success]="attempt.success"
                            [class.bg-danger]="!attempt.success">
                            <i class="fas fa-circle text-white" style="font-size: 8px;"></i>
                        </div>
                        <div class="timeline-content">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex justify-content-between align-items-start mb-2">
                                        <h6 class="card-title mb-0">
                                            <i class="fas fa-redo-alt me-1"></i>Intento #{{ attempt.attempt }}
                                        </h6>
                                        <span class="badge" [class.text-bg-success]="attempt.success"
                                            [class.text-bg-danger]="!attempt.success">
                                            {{ attempt.success ? 'EXITOSO' : 'FALLIDO' }}
                                        </span>
                                    </div>

                                    <div class="row text-sm">
                                        <div class="col-md-12">
                                            <small class="text-muted">Fecha y Hora</small>
                                            <div>{{ attempt.timestamp | date:'dd/MM/yyyy HH:mm:ss' }}</div>
                                        </div>
                                    </div>

                                    <div *ngIf="attempt.error" class="mt-2">
                                        <small class="text-muted">Error</small>
                                        <div class="text-danger small">{{ attempt.error }}</div>
                                    </div>

                                    <div *ngIf="attempt.error_details" class="mt-2">
                                        <small class="text-muted">Detalles del Error</small>
                                        <div class="small bg-light p-2 rounded">
                                            <pre class="mb-0">{{ attempt.error_details | json }}</pre>
                                        </div>
                                    </div>

                                    <div *ngIf="attempt.response" class="mt-2">
                                        <small class="text-muted">Respuesta de la Aseguradora</small>
                                        <div class="small bg-light p-2 rounded">
                                            <pre class="mb-0">{{ attempt.response | json }}</pre>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- No History Message -->
                <div *ngIf="!selectedInsuranceReportPayment?.params?.insurance_report?.history || selectedInsuranceReportPayment.params.insurance_report.history.length === 0"
                    class="text-center py-4">
                    <i class="fas fa-history fa-3x text-muted mb-3"></i>
                    <h5 class="text-muted">Sin historial disponible</h5>
                    <p class="text-muted">Este pago aún no tiene intentos de reporte registrados.</p>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                    (click)="closeInsuranceReportHistoryModal()">Cerrar</button>
            </div>
        </div>
    </div>
</div>
<!-- 🖼️ MODAL DE VISUALIZACIÓN DE IMÁGENES -->
<ng-template #fileViewerModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fas fa-image me-2"></i>
      Imagen Adjunta
    </h5>
    <button type="button" class="btn-close" (click)="closeFileModal()" aria-label="Close"></button>
  </div>
  <div class="modal-body text-center p-4" style="display: flex; align-items: center; justify-content: center; min-height: 400px;">
    <!-- Mostrar imagen -->
    <div *ngIf="selectedFileType === 'image'" class="image-container" style="width: 100%; display: flex; justify-content: center; align-items: center;">
      <img [src]="selectedFileUrl" 
           alt="Archivo adjunto" 
           class="img-fluid rounded shadow-sm"
           style="max-width: 100%; max-height: 70vh; object-fit: contain; display: block; margin: 0 auto;"
           (error)="selectedFileType = 'error'">
    </div>
    
    <!-- Error al cargar -->
    <div *ngIf="selectedFileType === 'error'" class="text-center">
      <i class="fas fa-exclamation-triangle text-warning" style="font-size: 3rem;"></i>
      <h5 class="mt-3">No se pudo cargar la imagen</h5>
      <p class="text-muted">La imagen no se puede visualizar en el navegador.</p>
      <a [href]="selectedFileUrl" target="_blank" class="btn btn-primary mt-2">
        <i class="fas fa-external-link-alt me-1"></i>
        Abrir en nueva pestaña
      </a>
    </div>
  </div>
  <div class="modal-footer justify-content-between">
    <button type="button" class="btn btn-primary" (click)="downloadCurrentFile()">
      <i class="fas fa-download me-1"></i>
      Descargar
    </button>
    <button type="button" class="btn btn-secondary" (click)="closeFileModal()">
      <i class="fas fa-times me-1"></i>
      Cerrar
    </button>
  </div>
</ng-template>

<!-- Modal compartido "Confirmar reporte a la aseguradora" (mismo flujo que la Consola de Seguros) -->
<app-insurance-report-confirm
  [payment]="insReportPayment"
  [open]="insReportOpen"
  (openChange)="insReportOpen = $event"
  (reported)="onInsuranceReported()">
</app-insurance-report-confirm>
